import { useMemo } from 'react'
import { VOIP_ADMIN_BASE } from '@/core/voip/config'

/**
 * VoIP tab — embeds the standalone VoIP admin portal
 * (apps/admin-portal in the VoIP repo, served at VOIP_ADMIN_BASE).
 *
 * The portal is designed to be iframed here: it reads the chatapp JWT
 * from a `?token=` query param and the control-plane validates it via the
 * shared MYEXPERT_JWT_SECRET, so no separate VoIP login is needed. Admin
 * portal features (agents, greetings, call-flow editor, voicemail, audit,
 * history) live entirely in that app.
 */
export function VoipTab() {
  const token = useMemo(() => localStorage.getItem('authToken'), [])

  const src = useMemo(() => {
    if (!token) return null
    const url = new URL(VOIP_ADMIN_BASE)
    url.searchParams.set('token', token)
    return url.toString()
  }, [token])

  if (!src) {
    return (
      <div className="p-6">
        <h2 className="text-xl font-bold mb-2">VoIP</h2>
        <div className="bg-red-50 text-red-700 p-4 rounded-xl">
          Vous devez être connecté pour accéder à l'administration VoIP.
        </div>
      </div>
    )
  }

  return (
    <div className="h-full w-full">
      <iframe
        src={src}
        title="VoIP Admin"
        className="w-full h-full border-0"
        // Portal records greetings/voicemail from the mic and plays audio back.
        allow="microphone; autoplay; clipboard-write"
      />
    </div>
  )
}
